import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { streckenTarifierungThhHund } from './streckenTarifierungThhHund';
import { shopTarifierungThhHund } from './shopTarifierungThhHund';
import { watchProduktlinienSaga } from './produktlinienSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { watchVersicherungssummen } from './versicherungssummenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchVorbelegungRequested } from './vorbelegungSagaHund';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { handleThhHundNavigationToAngebotSaga } from './handleThhHundNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    streckenTarifierungThhHund(),
    watchVorbelegungRequested(),
    shopTarifierungThhHund(),
    watchProduktlinienSaga(),
    watchInDashboardUebernehmenSaga(),
    watchVersicherungssummen(),
    watchAntragsnummerRequested(),
    watchDruckdatenChanged(),
    watchVorschlagdatenChanged(),
    watchQuoteDB(),
    handleThhHundNavigationToAngebotSaga(),
  ]);
}
